import React from 'react';
import {CartItemDataHook} from '../../CartItem';
import {useControllerProps} from '../../../../../../domain/controllers/ControllerContext';
import {classes} from '../../CartItem.st.css';
import {ICartItem} from '../../../../../../types/app.types';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {DeleteSmall} from '@wix/wix-ui-icons-common/on-stage';

export const Remove = ({item}: {item: ICartItem}) => {
  const {t} = useTranslation();
  const {removeItemFromCart} = useControllerProps().cartStore;

  return (
    <button
      className={classes.remove}
      type="button"
      aria-label={t('cart.sr_remove_item_from_cart', {item_name: item.product.name})}
      onClick={() => removeItemFromCart(item)}
      data-hook={CartItemDataHook.Remove}>
      <DeleteSmall />
    </button>
  );
};
